import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const featureToggleService = {
  getFeatureToggles: async () => {
    const response = await fetch(`${API_URL}/feature-toggles`, {
      method: 'GET',
    });
    const data = await response.json();
    return data.toggles;
  },

  updateFeatureToggles: async (toggleData) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/feature-toggles`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(toggleData),
    });
    const data = await response.json();
    return data.session ? handleSessionExpire() : data.toggles;
  },
};

export default featureToggleService;
